import { SvgIcon } from "./SvgIcon";

function IconComponent(props: any) {
  return (
    <SvgIcon {...props} color="red" stroke="blue" viewBox="0 0 16 16">
      <path
        d="M5 14L11 8L5 2"
        fill="none"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default IconComponent;
